import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import {storePatientIdAction} from './patient.action'
export class storePatientIdModel{
    patientId:any
    pageType:any
 
 }
 @State<storePatientIdModel>({
     name: 'patientId',
     defaults: {
        patientId:0,
        pageType:null
      }
 })
 @Injectable()
 export class storePatientIdState {
 
     constructor( ) {
     }
 
     @Selector()
     static getPatientId(state: storePatientIdModel) {
         return state;
     }
     @Action(storePatientIdAction)
     storePatientIdAction({getState, patchState}: StateContext<storePatientIdModel>, {payload}: storePatientIdAction) {
         const state = getState();
         patchState({
              patientId:payload.patientId,
              pageType:payload.pageType
         });
     }
    //  @Action(storePageTypeAction)
    //  storePageTypeAction({getState, patchState}: StateContext<storePatientIdModel>, {payload}: storePageTypeAction) {
    //      const state = getState();
    //      patchState({
    //           pageType:payload
    //      });
    //  }
    } 